module.exports = __webpack_public_path__ + "static/media/inf_56og66.4b282d93.mp3";